var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g3, _g4, _g5, _path33;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-sm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#19b6ef",
    d: "M0 256h512v256H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v256H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.4,
    d: "M252.9 361.8C308.8 320 369 234.6 298.5 189.7c-13.2-2.6-27.9-1.8-35 3.8-3.7-2.2-6.6-2-10.4 2-2.6-3.2-5.2-4.7-10.7-3a43.6 43.6 0 0 0-33.6-3.4c-61.5 37-23.9 124.6 44 172.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#3a9d4f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M356.3 266.8s6.3-8.5 6.5-8.5c6.3-3.7 7-8.5 7-8.5 6.3-2 4.3-7.1 4.8-7.8a6.9 6.9 0 0 0 1.5-7.6c0-.9 2.2-8.9-.9-10 .2-8.5-5.1-7.7-9.3-2.1-4.5 1.3-5.5 5-4 9-5.8 0-6 8.5-4.3 13.3-7.8-.2-3.4 8.5-3.7 9-2.6 1.2 2 13.6 2.4 13.2zM307 339.5l4 2.4c.7 3 3.5 4.8 5.6 4.3 1 4.6 6 4 9.5 1.3 3 4.2 6.5 4.3 11.3 2.9 4.4 3.2 10 1.8 13.7-1.6 4 3.3 6.7 1 8.7-2.6 3.1.8 5.6.3 6.7-2.8 6.1-.5 3-6.2-2-8.7 4-3.4 8.5-10.6 2.2-11.7-2-1.4-5.6-1.1-8.4.2-.7-3.2-5.2-4-10-.4-1.7-3.6-7.5-1.9-10.2.6-3.5-3-7.6-3-13.7.5L307 339.5zm0-9.3c.7-4-2-11.2 2.2-12-.8-6.6.4-14.1 8-13.4 1.3-6.3 1-12.2 8.3-13 0 0 5.9-20.5 12-6.3 2.3 4 1.9 10.8-2.9 9.5 1 5-.7 9.5-6.3 9.3 2.5 3.6 1.7 8.4-1 10.7L307 330.2zm35.4-25.4 6.3-1.3c6.5-4.4 9.1-6.1 12.4-1.3 5.4-1.2 10.6-.6 10.4 3.7 6.5.4 6.4 4.5 5.7 7.8 1 5.7-1.5 13.2-5.5 4.1-12.6-7.7-19.7-6.7-39.7-2.2l10.4-10.8zm3.3-6.3c.2-.2 18.7-5 16.7-10.7 5.2-.8 6.3-6 6.5-6 10.9-3.5 10.2-9.8 10.2-9.8 3.1-3.4 8.6-6.7 7.4-12.6.4-6.7 1-10.9-8-6.5-6.8-.7-9.1 3.2-11.1 9-3.2-3.7-8.3 2.3-8.9 7.7 0 0-8.3 8-8.3 8.2l-6.9 12.8 2.4 7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M346.1 284.1c-4.4-3.3-6.9-7.3-6-11.3-3-3.9-5-6.3-2.2-9.7l-2.2-8c-5.7-2.2-3.3-7-1.7-8.7-2.7-3.7-2.8-7.6-.3-11.1 0-7 4.9-4.4 9 0 0 0 6.7 4.8 1.7 9.1 5 1.7 6.5 6 3.7 7.8 4.3 2 5 5.9 2.6 8.5 4.4 3.5 2.7 8 4.1 12l-8.7 11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M354 251.8c-.3-.2-7.5-9.4-5.5-10-.4-2.8-2.6-5.9-1.3-8.7-3.5-3.5-3.6-7.7-.9-11-2.4-3.3-1.3-7.7 2-10.5-1-5.3 2.7-6.6 6-7.6 2.5-8.6 6.5-6.4 8.8.2 3.4 3 2.9 7.5 1.7 10.9 4 2.7 1.6 6.1-.2 7.6l-10.7 29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4fd46b",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "m352.9 206-6.1-6.1c1.5-3.2 2.8-9-1.8-11.5-2.5-6.2-15-13.8-17.1.8-2-4.4-6-8.7-9-3.6-6.5-5.7-10-4-6.6 3.2 0 0-3 4.8 5 8.5.6.6-2.7 8.7 6.9 8.9-1.8 2.7 1.2 6.6 5 6.3-2.8 3.4 1.9 7 4.8 5.6-1.3 3.8-1.2 5.6 4 6.1l6 6.7 4.7 6.6 4.1-31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M356.6 263c.2-.4 11.6-26.5 13.1-34.5m-12-12s2 21.3-3.3 37M322.8 195s23.3 22.4 25.5 31.6m-9.3-34s1.6 18.4 8 36.5m33.2 30.4s-23.3 19.6-34.7 36.8m12.6 32s-30.7 4.2-44.2 4.5m34 8.7s-38-1-40.8-3.7M329 292c0 .3-19.3 32.2-20 42.7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#65c7ff",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.4,
    d: "M252.7 355.7c-40.3-38-81.6-109.4-40.5-145.4 7.2 4.1 15.9.4 27.7-4.2 3.6 3.9 8.2 4.9 12.7 2 5.2 2.1 9 .4 11.5-2.4 11.6 6.8 26.5 10.3 30 3.6 40.4 38.4-.5 110-41.5 146.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8fc753",
    fillRule: "evenodd",
    d: "M252.9 354.6a227.1 227.1 0 0 1-45.2-61.5c2-1.8 3-2.3 4.1-5.4a46 46 0 0 0 17.7-.3c1.6 6.1 2 11.2 5.8 16.3l8.2-16a36 36 0 0 0 17.6 0c3.4 4.6 2.2 11.5 8.2 16.7 3.6-10.6 7.2-11.3 10.8-17 5.3 1.9 8.7 1 13-.3 2.3 2.6 1.2 2.5 5.4 6.4a206.4 206.4 0 0 1-45.6 61z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M205.5 175.3a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-3.7-8.3a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-4.4-7.6a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm-3-7.4a3.6 3.6 0 1 1-7 0 3.6 3.6 0 0 1 7 0zm.5-8.1a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm18.9-13.3a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-7.1 1.2a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm-7.7 4.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm23.9-5.8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm9.9.8a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7 0zm8.8-.5a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 1.1,
    d: "M262.3 125.3a9.2 9.2 0 1 1-18.4 0 9.2 9.2 0 0 1 18.3 0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M271.9 130.9a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm9.3.7a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm9-.4a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm7.6-.3a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm9.5 1a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm7.4 4.7a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e40000",
    fillRule: "evenodd",
    stroke: "#ac0000",
    strokeWidth: 2.4,
    d: "m202 161.8 9.2 17.6h84.5l9.7-17c-5.7-3.9-9.6-6.9-17.7-5-4.7-6.7-9.7-8-17.2-7.2a12.3 12.3 0 0 0-8-4.2l-17.8.5c-4.6.4-8.2 4-8.4 4-7.6-1-14.5-.7-16.3 6.6-6.9-1.7-11.7.2-18 4.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M317.8 144.4a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm.6 8.3a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm-2.6 7.8a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zm-3.3 6.4a3.6 3.6 0 1 1-7 0 3.6 3.6 0 0 1 7 0zm-3.8 8a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-50-10.2a5.3 5.3 0 1 1-10.5 0 5.3 5.3 0 0 1 10.5 0zm1-12.1a6.4 6.4 0 1 1-12.7 0 6.4 6.4 0 0 1 12.8 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M258.9 140.8a5.7 5.7 0 1 1-11.5 0 5.7 5.7 0 0 1 11.5 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 1.1,
    d: "M251.2 116.3v-4.6h-3.8l.1-3.4h3.3v-3h4.7v2.7h3.7v3.6h-3.9v4.8h-4.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fd0",
    strokeWidth: 3.3,
    d: "M210.7 179.4c-7.5-12.9-18.7-30.3-11.8-37.8 9.6-10.9 32-1 46.3-7.4 1 12.3-2.4 32.5 3.1 36.7l-5.1 4.5c-3.1-4-9-9.4-16.3.2-4.1-3.6-8.8-3-11 1.8-2.2.3-2 1.2-5.2 2zm85.5-.5c7.5-12.8 18.7-30.2 11.8-37.8-9.6-10.8-32-1-46.3-7.3-1 12.2 2.4 32.4-3.1 36.7l5.1 4.4c5-6.9 11-7.1 16.2.3 4.2-3.7 8.5-3.2 11.1 1.8 2.2.3 2 1.1 5.2 2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd0",
    fillRule: "evenodd",
    stroke: "#7d6c00",
    strokeWidth: 2.4,
    d: "M210.5 189a466 466 0 0 1 84.5 0l3.3-9.6c-29.5-5.4-49.9-6-88.5-.7l.7 10.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "m249.7 351.3.7-4.5c3 .9 5.3.5 7.8-.4l2.6-3.9-2-2.3c-1.7.4-3 2-4.2 3.4-1.7 0-3.2-.8-4.9-1.1l-1.6-6.9c-1.6-1.9-5-1.7-4.3 1.7l.4 2.6c.6 1.6.9 3.9 2 5v2.8l3.5 3.6zm1.3-19.5c-2.3 1.1-5-.8-7.8-2-2.6-.1-4.7 2-7.9 1.4.6-1.7 2-2 3-3-.7-4.4 1.6-5.9 2.3-5.9.6 0 3.2.7 3.2.7l2.6.3c1.6 2.8 3.7 5.4 4.6 8.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe100",
    fillRule: "evenodd",
    stroke: "#e9bf00",
    strokeWidth: 2.4,
    d: "M235.5 390.5c7.5-12.3 60-36.8 109.2-89.9-50 48.3-81.4 60.1-122.4 89.6l13.2.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9d4916",
    fillRule: "evenodd",
    stroke: "#68300e",
    strokeWidth: 1.1,
    d: "M307.6 334a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0zm36.7-37.1a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0zm12.2-31.6a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0zm-12-41a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#a9a9a9",
    strokeWidth: 1.1,
    d: "M212.4 287.6v-16.2l-1.7-1.4v-3.8l3-.3.6-18-2-1.1-.2-3s2.2.8 2.2.2l.5-3.5s-1.3-.3-1.3-.9 1.6-1.9 1.6-1.9-.8-.8-1-1.3l-.9-3 .8-3-.5-1.7-1.4-2.5 2-1.9-.6-3c0-.5 1.3-2.8 1.6-3l2.5-3.3 4.6-1.1 5.5.8 3 2 .6 4.9s-.6 3-.8 3l-2.5 1s-2.7.3-3 0 .8 3.3.8 3.3v3.3l-.3 4.1s0 2-.2 2.2l-.9 1.1-.2 4.1 4.3 1.1-.2 2.5-3 .3.5 16.7 4.4.8v4.7l-2 1-.5 16.8h-15.3zm66.5.2v-16.1l-1.6-1.4v-3.8l3-.3.6-18-2-1.2-.2-3s2.2.8 2.2.3l.5-3.6s-1.4-.2-1.4-.8 1.7-1.9 1.7-1.9-.8-.8-1.1-1.4-.8-3-.8-3l.8-3-.6-1.6-1.3-2.5 1.9-2-.6-3a10 10 0 0 1 1.7-3l2.4-3.2 4.7-1.1 5.5.8 3 2 .5 4.8s-.5 3-.8 3-2.5 1.2-2.5 1.2-2.7.2-3 0 .9 3.2.9 3.2v3.3l-.3 4.1s0 2-.3 2.2l-.8 1.1-.3 4.1 4.4 1.1-.3 2.5-3 .3.6 16.7 4.3.8v4.6l-1.9 1.1-.5 16.7h-15.4zm-33.6.6v-16.2l-1.7-1.3V267l3-.2.6-18.1-2-1.1-.2-3s2.2.8 2.2.3l.5-3.6s-1.4-.3-1.4-.8 1.7-2 1.7-2l-1.1-1.3c-.3-.5-.8-3-.8-3l.8-3-.6-1.7-1.3-2.4 1.9-2-.6-3a10 10 0 0 1 1.7-3l2.5-3.3 4.6-1 5.5.8 3 1.9.5 4.9s-.5 3-.8 3-2.4 1.1-2.4 1.1-2.8.3-3 0 .8 3.3.8 3.3v3.3l-.3 4s0 2-.3 2.3c-.3.2-.8 1-.8 1l-.3 4.2 4.4 1-.3 2.5-3 .3.6 16.7 4.4.8v4.7l-2 1-.5 16.8h-15.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M216.4 287.4v-12.7h7.2V288l-7.2-.6zm33.6 1 .3-13h6.4v12.8l-6.6.3zm33.2-.2-.5-12.2 6.8-.3v12.8l-6.3-.3zm-65-38.5h4v6.7h-4zm32.4.3h5.6v6.4h-5.6zm33 .5h5v6.1h-5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#a8a8a8",
    strokeWidth: 1.1,
    d: "M220.3 220.8c4.4 4.9 4.7 4.9 4.7 4.9m28-5c.7 1.7 2.1 5.3 3.8 5.5m31.2-4.6s1.3 3.8 3.3 4.3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#b97700",
    fillRule: "evenodd",
    d: "M215.7 207c12.8-4.2-3-12.5-5.6 0-4.2.6-4.7 3.7-13.7 2.3-21.7 35.4-5.6 92.3 57.8 151.3-113.6-96.6-67.4-168-36-165.4 17.1 1.2 8.5 22.5-2.5 11.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#7d6c00",
    strokeWidth: 2.4,
    d: "M219.2 188.8s10.5 2.8 10.5 7.3m0-8s7.2 3.1 8.8 6m48.1-4.8s-9.2 1.1-11.2 4m-2.8-3.3s-5.2 4.5-4.8 5.7m3.6 13.6c-.8-.4-4.4-5.2-3.6-11.2m-31.7 8s2.4-2.8 2.4-8m14.4-2 .4 11.6m10-1.6c0-.8 3.3-8.4-.3-12m-21.7-1.6s-2.8 7.6-.8 14m21.3-7.2s-4.4 1.2-6.4 3.2m-12.5-2c0-.4 4.8-1.2 6.4 1.6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "M235.3 322c.2 0 4-.7 4-2.6 2-1.2.5-4.7.5-4.7l-3.6-.7-4.9-5.6c-.2-1.7.4-3.3-.7-5-3.4.8-5.3 3.6-6.5 6.9.9 1 1 2.1 2.5 3 1.6.3 2.7-.6 4.2-.3.8 1.3.6 2.5.8 3.7 2 1.5 2.5 3.5 3.7 5.3zm-4.4-23.7v-6.6l-4.7-.1c-.6 1-1.7 1.4-2.4 2.3l-3.2 1.6c1.3 1.7 3 2.6 4 3.4 2.5.7 4.4.7 6.3-.6zm-14.8 9.7-2.5-4.3a7.7 7.7 0 0 1 5 .3s1.1 2.7.3 3.7c-.4 1-2.9.5-2.8.3zm39 4.4a4.7 4.7 0 0 0 2.9-3.5l-4.8-5.5H249c-1-1.1-2.6-1.3-3.9-1.3 0 0 1.4 2 3.1 2.5 1.3 2.7 6.6 7.8 7 7.8zm4.6.7a16 16 0 0 1 6.5-1.4c-.2-1.7 3.1-5.7 3.1-5.7l6 7.8c-1.1.9-3 .6-4.5.9 0 0-2.9 2.8-3.2 2.9s-5.5 1.3-8-.2c-1.2-2.2.2-4.7.1-4.3zm3.4-13.7c.7-2.5 1-5 0-8 0 0-6.8-.2-6.8 0l-4.5 2s1.5 4.5 3.2 4c.8 2.4 3.1 1.8 4.2 2.6l3.9-.6zm26.5-6.8c-.9 2.8-1.4 5.8 0 8.6 1.2.2 2.6 1 3.7.8l5.5-9.8c-3.8-1.2-6.8-1.1-9.2.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#b97700",
    fillRule: "evenodd",
    d: "M291.3 206c-12.8-4 3-12.4 5.6 0 4.2.7 4.7 3.8 13.7 2.5 21.6 35.3 5.6 92.3-57.8 151.2 113.5-96.6 67.4-168 36-165.4-17.2 1.2-8.5 22.5 2.5 11.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#c76e2e",
    fillRule: "evenodd",
    d: "M292.6 303.6c-.2 0-3.3 2.3-3.3 2.3l-4.4 1.7-4.7.1-1-3.2 3.6-3.2c-3-.5-6.1.7-8.5 3 0 0 0 3.5 2 5.3a41 41 0 0 0 4.8 4.3c2.3.4 4.4 0 5.9-1.1l5.6-9.2zm-24.8 32.2c1.5.4 12.1-13.6 12.1-13.6a10.7 10.7 0 0 0-5.2-5.8s-5.2 6-5.3 8.1c-.8 1.9-3.1 9-2.1 9.9-.1.2-.5 3 .5 1.4z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M198.8 338.6c-15.8-13.8-37.2-21.4-67-11 8 3.4 16.7 4.6 24.1 8.3l42.9 2.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M153 328.8c31.2.6 40.3 8.4 38.6 7.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    d: "M199.4 340.2c-9.3 1.8-22.2 10.8-26 10.4-10.1-1.2-19.7-5.4-29.5-8.5-4.1-1.3-8.2 0-12.4 0 35-16.6 47-14.3 68-2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M176.4 315.8s-11.7 1.6-17 2c-5.1-.4-12.7-5.2-21-14-4.4-4.8-14.3-4.2-14.3-4.2 22-4.7 39-.3 52.3 16.2zm-16-22.7c-15.9-1-35.7-15.3-40.2-32.2 0 .3 5.8 3.7 4.9 4.6 26 6.6 27.8 11.9 35.4 27.6zm26.7 27.3c2.3-14.4 3-24-4-32.5-5.5-6.5-7-10.4-11-19.5-1.1 19-5.2 34.6 15 52zm-25-40c11.8-17.2 13.8-30.2 12-50.6a88.4 88.4 0 0 1-4.6 11.7c-17.5 11-9.7 28.2-7.4 39z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M151.7 197.3c11.8 17.2 10 33.4 8.1 53.9a89.1 89.1 0 0 0-4.5-11.7c-17.6-11-5.9-31.5-3.6-42.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M161.4 224c28.6-14.5 17.6-32.8 22.8-46.9-19.8 14.8-22.4 30.5-22.8 46.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M165.3 220.3c3.6-10 10.7-27.2 11.4-27.2m-19.8 48.4c-.7-7.2-4.2-26.4-4.6-28.3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#006800",
    fillRule: "evenodd",
    stroke: "#004100",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M158.2 273.6c-16-1-33.1-22.7-37.7-39.6 0 .2 5.9 3.6 4.9 4.5 22.8 10.2 25.2 19.4 32.8 35zm-4.7-15c-11.8-17.2-13.9-30.2-12-50.6.3 1.6 4.2 11.7 4.5 11.7 17.5 11 9.7 28.2 7.5 39zm10.5-30.1c29.6-13.1 20.5-26.9 29.3-41.3-19.8 14.7-29 25-29.3 41.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M165.3 225.5c12-12 16.3-22 16.3-22"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe100",
    stroke: "#e9bf00",
    strokeWidth: 2.4,
    d: "m270.4 390.8 14.4.3c-47.7-44.8-139.3-64.3-126.5-146.6C145 333.8 233 342 270.4 390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9d4916",
    stroke: "#68300e",
    strokeWidth: 1.1,
    d: "M165.8 226.8a4.6 4.6 0 1 1-9.2 0 4.6 4.6 0 0 1 9.2 0zM163 252a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0zm4 36a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0zm33.4 39.7a3.8 3.8 0 1 1-7.7 0 3.8 3.8 0 0 1 7.7 0zm4.8 11.4a3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 7.6 0z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222 372.3a16.7 16.7 0 0 1-5-6.2l-15-1.7-.2 8.6 20.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M112.3 362.2c8.7 1.6 21.8-.8 26.1 4.8 5.2 5.8-16 14.8-13 19.8 6.5 7 13.3 4.1 20.6.3 1.8-3.8 3.1-10.5 4-12.5-2.6-6.1-9.8-9.1-8-18.4 12.2-4.6 35.5-4.2 38-2.4 2 3.8.2 5.6.6 8.7-2 3.8-7.2 10.4-7.2 14 12.7 4.4 16-.8 27.5-.5 13.4.2 21.6 3.8 24.5-1.5-2-4.6-14.3-.9-19-3.9-2.3-.8-3.8-2.6-5.8-4.7s-7.7-2.2-8.6-7.3c2.4-10.9 18.1-9.2 20.7-10.9l41 2.8c7.4-.2 11.6 13.2 1.6 17.2s-39.7-6-52.5 1c-.7-2.9-10-7.1-10.6-7.3-4 1.2-11.6.8-11.6.8-1.9 3.5-4 6-5.9 9.5-8.5-3.7-16.5 2.9-25.8 1l-14.5 1.5-9.2-.8-14 4 10-8.8-8.9-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 360.5a3.9 3.9 0 1 1-7.7 0 3.9 3.9 0 0 1 7.7 0zm-1 19.1a3.9 3.9 0 1 1-7.8 0 3.9 3.9 0 0 1 7.8 0z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284 372.4c2.5-2.3 4-3.8 5-6.3l15-1.6.3 8.6-20.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M393.7 362.3c-8.7 1.6-21.8-.8-26 4.8-5.2 5.8 16 14.8 13 19.8-6.6 7-13.3 4.1-20.7.3-1.7-3.8-3-10.5-4-12.5 2.7-6.1 9.9-9.2 8-18.5-12.1-4.5-35.4-4.1-38-2.4-2 3.9-.1 5.7-.5 8.7 2 4 7.1 10.5 7.1 14-12.7 4.5-16-.7-27.5-.4-13.4.2-21.6 3.8-24.5-1.6 2-4.6 14.3-.8 19-3.8 2.3-.8 3.8-2.7 5.9-4.7s7.7-2.2 8.5-7.3c-2.4-10.9-18.1-9.2-20.7-10.9l-41 2.8c-7.4-.2-11.5 13.2-1.5 17.2s39.6-6 52.5.9c.7-2.8 9.9-7 10.6-7.2 3.9 1.2 11.6.8 11.6.8 1.8 3.4 4 6 5.9 9.5 8.5-3.8 16.5 2.9 25.8 1l14.4 1.5 9.3-.8 14 4-10-8.8 8.8-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.4 360.5a3.9 3.9 0 1 0 7.7 0 3.9 3.9 0 0 0-7.8 0zm1 19.2a3.9 3.9 0 1 0 7.7 0 3.9 3.9 0 0 0-7.7 0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.8 351.3c-3.5-.7-4.7-.5-7-.7l-5.5 16.9c8.4.7 16.3.7 16.3.7-5.1-1-3.9-16.8-3.8-17z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Trebuchet MS",
    fontSize: 9,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217 363v-11.5h2v9.6h5.4v1.8z",
    "aria-label": "L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226 363.5V352h2v11.4z",
    "aria-label": "I"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.8 364.3h-3.5V353l3.4-.2q1.7 0 2.6.7 1 .9 1 2.3 0 1.3-1.3 2.1 2.1.8 2.1 3 0 1.7-1.2 2.6-1.1.8-3 .8zm-1.4-9.7v2.6h1q1.9 0 1.9-1.4 0-1.2-1.8-1.2h-1zm0 4.2v3.8h1q1.3 0 1.9-.4.7-.3.7-1.4 0-1-.6-1.4-.5-.6-2-.6h-1z",
    "aria-label": "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.9 355.3v2.8h3.7v1.8H244v3.4h5.3v1.7H242v-11.3h7.2v1.8z",
    "aria-label": "E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.5 365.2-3-4.8H254v4.8h-2V354h1.3l1.8-.2q4.4 0 4.4 3.4 0 1-.5 1.7-.7 1-1.6 1.3l3.6 5.1zm-4.5-9.6v3h1l1.7-.1q.7-.4.7-1.4 0-1-.5-1.3-.7-.3-2.2-.3h-.7z",
    "aria-label": "R"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.6 355.3v9.6h-2v-9.6H261v-1.8h9.4v1.8z",
    "aria-label": "T"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.2 363.3-.9-2.3h-4l-.6 2.3h-2.3l4.6-11.6h.9l4.6 11.6zm-2.9-8.2-1.2 4.3h2.7z",
    "aria-label": "A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.1 362.4.7-1.8q1.3.7 2.3.7 1.8 0 1.8-1.2l-.4-1-1.7-1.3-1.8-1.1-.7-1-.2-1.3q0-1.4.9-2.3 1-.7 2.5-.7 2 0 3 .7l-.7 1.8q-1-1-2.3-1-.7 0-1 .4-.4.4-.4 1 0 1 2 2 1.3.6 1.9 1.1l.7 1 .1 1.5q0 1.4-1 2.3t-2.9.9q-1.7 0-2.8-.9z",
    "aria-label": "S"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00a400",
    strokeLinecap: "round",
    strokeWidth: 2.2,
    d: "M161.4 339.8c10.8 1.3 25.7.4 32.2 0m-48.4-36.7c9 7.2 28.9 11.4 28.6 11.4m11.3 2c-2.9-15-6.1-18.5-8.7-28m-46.5-16.9c15.3 6.9 17.6 11.4 27.3 18.2m5.5-15c1.3-18.4 4-23.3 8.5-27.5m-41.3-2.3a2102 2102 0 0 0 23.7 25.3m-7.4-42.2c6.8 4.9 6.8 22.4 6.8 22.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.7f0fe9fe91337a9068532afe61280f7c.svg";
export { ForwardRef as ReactComponent };